import React, { useCallback, useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import PriceField from "Components/UI/Form/PriceField";
import { InputAdornment } from "@mui/material";
import dayjs from "dayjs";
import DateWithClear from "Components/UI/Form/DateWithClear";

export default function Payment({ client, FORM_MODE, handleReplaceFormData }) {
  const [formData, setFormData] = useState(client);

  useEffect(() => {
    if (client) {
      setFormData(client);
    }
  }, [client]);

  const handleInputChange = useCallback(
    (field, newVal) => {
      setFormData({ ...formData, [field]: newVal });
    },
    [formData]
  );

  const handleBlur = () => {
    handleReplaceFormData(formData);
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6} md={4}>
        <TextField
          name="BankGiroNumber"
          disabled={FORM_MODE === "LOCKED" ? true : false}
          label="Bankgiro"
          value={formData?.BankGiroNumber}
          onChange={(e) => handleInputChange("BankGiroNumber", e.target.value)}
          size="small"
          fullWidth
          margin="dense"
          onBlur={handleBlur}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <TextField
          name="PlusGiroNumber"
          disabled={FORM_MODE === "LOCKED" ? true : false}
          label="Plusgiro"
          value={formData?.PlusGiroNumber}
          onChange={(e) => handleInputChange("PlusGiroNumber", e.target.value)}
          size="small"
          fullWidth
          margin="dense"
          onBlur={handleBlur}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <TextField
          name="BankBICCode"
          disabled={FORM_MODE === "LOCKED" ? true : false}
          label="BANK/BIC-kod"
          value={formData?.BankBICCode}
          onChange={(e) => handleInputChange("BankBICCode", e.target.value)}
          size="small"
          fullWidth
          margin="dense"
          onBlur={handleBlur}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <TextField
          name="BankAccountNumberIBAN"
          disabled={FORM_MODE === "LOCKED" ? true : false}
          label="Bankkontonr/IBAN"
          value={formData?.BankAccountNumberIBAN}
          onChange={(e) =>
            handleInputChange("BankAccountNumberIBAN", e.target.value)
          }
          size="small"
          fullWidth
          margin="dense"
          onBlur={handleBlur}
        />
      </Grid>

      <Grid item xs={12} sm={6} md={4}>
        <PriceField
          name="SubscriptionFee"
          disabled={FORM_MODE === "LOCKED" ? true : false}
          label="Årsavgift belopp"
          value={formData?.SubscriptionFee}
          onChange={(newVal) => handleInputChange("SubscriptionFee", newVal)}
          size="small"
          fullWidth
          margin="dense"
          InputProps={{
            endAdornment: <InputAdornment position="end">SEK</InputAdornment>,
          }}
          onBlur={handleBlur}
        />
      </Grid>

      <Grid item xs={12} sm={6} md={4}>
        <DateWithClear
          label="Årsavgift kommande"
          value={dayjs(formData?.SubscriptionNextDate)}
          disabled={FORM_MODE === "LOCKED" ? true : false}
          onChange={(newVal) =>
            handleReplaceFormData({
              ...formData,
              ["SubscriptionNextDate"]: dayjs(newVal).format("YYYY-MM-DD"),
            })
          }
        />
      </Grid>

      <Grid item xs={12} sm={6} md={4}>
        <PriceField
          name="MinAmountForPayment"
          disabled={FORM_MODE === "LOCKED"}
          label="Minimibelopp för utbetalning"
          value={
            formData?.MinAmountForPayment
          }
          onChange={(newVal) =>
            handleInputChange("MinAmountForPayment", newVal)
          }
          size="small"
          fullWidth
          margin="dense"
          InputProps={{
            endAdornment: <InputAdornment position="end">SEK</InputAdornment>,
          }}
          onBlur={handleBlur}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <PriceField
          name="SubscriptionMonthlyFee"
          disabled={FORM_MODE === "LOCKED"}
          label="Månadsavgift belopp"
          value={
            formData?.SubscriptionMonthlyFee
          }
          onChange={(newVal) =>
            handleInputChange("SubscriptionMonthlyFee", newVal)
          }
          size="small"
          fullWidth
          margin="dense"
          InputProps={{
            endAdornment: <InputAdornment position="end">SEK</InputAdornment>,
          }}
          onBlur={handleBlur}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <DateWithClear
          label="Månadsavgift kommande"
          value={dayjs(formData?.SubscriptionMonthlyNextDate)}
          disabled={FORM_MODE === "LOCKED" ? true : false}
          onChange={(newVal) =>
            handleReplaceFormData({
              ...formData,
              ["SubscriptionMonthlyNextDate"]:
                dayjs(newVal).format("YYYY-MM-DD"),
            })
          }
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <PriceField
          name="InvoiceAmountLimit"
          disabled={FORM_MODE === "LOCKED" ? true : false}
          label="Fakturagräns SEK"
          value={formData.InvoiceAmountLimit ? formData.InvoiceAmountLimit : ""}
          onChange={(newVal) => handleInputChange("InvoiceAmountLimit", newVal)}
          type="number"
          size="small"
          fullWidth
          margin="dense"
          onBlur={handleBlur}
        />
      </Grid>
    </Grid>
  );
}
